import React, { useState, useEffect } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Identity } from '@wajeez-web/core/api-base';
import {
  useRolesSelector,
  useRolesDispatch,
  TeamActions,
} from '@wajeez-web/stores/roles';
import { InputSelect } from '@wajeez-web/components/ui';
const AssignRoleToUserModal: React.FC<
  CommonModalProps<Identity.UserRoleModel[]>
> = ({ isOpen, onClose, onSubmit }) => {
  const { userRoles } = useRolesSelector((state) => state.wajeezTeam);
  const [selectedRole, setSelectedRole] = useState<Identity.UserRoleModel[]>(
    []
  );
  const dispatch = useRolesDispatch();

  useEffect(() => {
    if (userRoles) {
      setSelectedRole(
        userRoles?.userRoles?.filter((ele) => ele.selected) || []
      );
    }
  }, [userRoles]);

  return (
    <Modal
      onSubmit={() => {
        onSubmit && onSubmit(selectedRole);
      }}
      open={isOpen}
      onClose={onClose}
      title="Assign Role to User"
    >
      <InputSelect
        options={
          userRoles?.userRoles?.map((r) => ({
            value: r.roleName,
            label: r.roleName,
          })) || []
        }
        label="Role"
        name="roleId"
        isMulti={true}
        value={selectedRole?.map((r) => ({
          value: r.roleName || '',
          label: r.roleName || '',
        }))}
        onChange={(name, val: any) =>
          setSelectedRole(
            val.map((ele: any) => ({ roleName: ele.value, selected: true }))
          )
        }
      />
    </Modal>
  );
};

export default AssignRoleToUserModal;
